import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { BrowserInfo, StorageEstimate } from '@/types/Diagnostics';

interface DiagnosticsSnapshot {
  storageEstimate: StorageEstimate;
  browserInfo: BrowserInfo;
  lastRefreshedAt: number;
}

export const refreshDiagnosticsThunk = createAppAsyncThunk<DiagnosticsSnapshot>(
  'debug/refreshDiagnostics',
  async(_, { extra: { diagnosticsService } }) => {
    const storageEstimate = await diagnosticsService.getStorageEstimate();
    const browserInfo = diagnosticsService.getBrowserInfo();
    return { storageEstimate, browserInfo, lastRefreshedAt: Date.now() };
  }
);
